import { useAuth } from '@/hooks/useAuth';
import { Clock, Mail, LogOut } from 'lucide-react';

export function PendingApprovalPage() {
  const { user, signOut } = useAuth();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-yellow-50 to-orange-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-xl">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-4 bg-yellow-100 rounded-full">
            <Clock className="w-8 h-8 text-yellow-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Access Pending Approval
          </h1>
          
          <p className="text-gray-600">
            Your account is awaiting approval from a manager
          </p>
        </div>

        <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg mb-6">
          <div className="flex items-start gap-3">
            <Mail className="w-5 h-5 text-blue-600 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm text-blue-900 font-medium mb-1">
                Account Information
              </p>
              <p className="text-sm text-blue-800">
                {user?.email}
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex items-start gap-3 text-sm text-gray-600">
            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2" />
            <p>
              A manager will review your request and assign appropriate permissions
            </p>
          </div>
          <div className="flex items-start gap-3 text-sm text-gray-600">
            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2" />
            <p>
              You will receive an email notification once your access is approved
            </p>
          </div>
          <div className="flex items-start gap-3 text-sm text-gray-600">
            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2" />
            <p>
              This process typically takes 1-2 business days
            </p>
          </div>
        </div>

        <button
          onClick={signOut}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors"
        >
          <LogOut className="w-4 h-4" />
          <span>Sign Out</span>
        </button>

        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500">
            Need help? Contact your system administrator
          </p>
        </div>
      </div>
    </div>
  );
}
